import { Backdrop, BackdropProps, Box, CircularProgress } from "@mui/material";
import React from "react";
// import styles from "@/styles/pages/home.module.scss";
import styles from "../../../styles/pages/home.module.scss";

// type SavingLoaderProps = {
//   open: BackdropProps["open"];
//   successText?: string;
//   processSuccess?: boolean;
//   text?: string;
//   onClose?: BackdropProps["onClick"];
// };
export default function SavingLoader(props) {
  const { open, onClose, processSuccess, successText, text } = props;

  if (processSuccess) {
    setTimeout(() => {
      onClose();
    }, 800);
  }
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
      onClick={onClose}
      className="backDropHome"
    >
      <Box className={`${styles.save_modal} ${styles.save_modal_bar}`}>
        {!processSuccess ? (
          <>
            <CircularProgress
              color="inherit"
              size="18px"
              className="progress_bar"
            />
            <p>{text || "Saving"}</p>
          </>
        ) : (
          <p>{successText || "Done"}</p>
        )}
      </Box>
    </Backdrop>
  );
}
